import React from 'react';

const Logo = ({ className = '', size = 'default' }) => {
  const sizes = {
    small: { container: 120, sphere: 32, text: 14 },
    default: { container: 200, sphere: 48, text: 20 },
    large: { container: 280, sphere: 64, text: 28 },
    xlarge: { container: 380, sphere: 80, text: 66 }
  };

  const currentSize = sizes[size];

  return (
    <div className={`logo-combined ${className}`} style={{ width: currentSize.container }}>
      {/* Dotted Sphere */}
      <svg 
        width={currentSize.sphere} 
        height={currentSize.sphere} 
        viewBox="0 0 100 100" 
        className="logo-sphere"
      >
        <defs>
          <radialGradient id="sphereGradient" cx="35%" cy="35%">
            <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.9" />
            <stop offset="20%" stopColor="#FFD1A0" stopOpacity="0.8" />
            <stop offset="50%" stopColor="#D4621F" stopOpacity="0.7" />
            <stop offset="80%" stopColor="#8B3A0F" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#3D1A08" stopOpacity="0.5" />
          </radialGradient>
        </defs>
        
        {/* Create dotted sphere pattern */}
        {Array.from({ length: 12 }).map((_, row) => (
          <g key={row}>
            {Array.from({ length: 12 }).map((_, col) => {
              const x = (col / 11) * 100;
              const y = (row / 11) * 100;
              const centerX = 50;
              const centerY = 50;
              const distance = Math.sqrt(Math.pow(x - centerX, 2) + Math.pow(y - centerY, 2));
              
              if (distance > 45) return null;
              
              const radius = 2.5 - (distance / 50) * 1.5;
              const opacity = 1 - (distance / 50) * 0.5;
              
              return (
                <circle
                  key={`${row}-${col}`}
                  cx={x}
                  cy={y}
                  r={radius}
                  fill="url(#sphereGradient)"
                  opacity={opacity}
                />
              );
            })}
          </g>
        ))}
      </svg>

      {/* Gradient Text */}
      <div className="logo-text-combined" style={{ fontSize: currentSize.text }}>
        SpaceGems
      </div>
    </div>
  );
};

export default Logo;
